const rates = {
  createRateBtn: 'Create',
  showBreakdownBtn: 'Show Breakdown',
  total: 'Total: ',

  table: {
    headers: {
      name: 'Name',
      code: 'Code',
      supplierName: 'Supplier',
      isAvailable: 'Available',
      isActive: 'Status',
    },
    filters: {
      code: 'Code',
      supplier: 'Supplier',
      profile: 'Profile',
      attributes: 'Attributes',
      service: 'Service',
    },
    cells: {
      isActive: {
        true: 'Active',
        false: 'Inactive',
      },
      isAvailable: {
        true: 'YES',
        false: 'NO',
      },
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
  },

  deleteModal: {
    header: 'Delete Rates',
    body: 'You are about to delete {{num}} rates.',
  },

  rateTypeOptions: {
    Base: 'Base',
    Addition: 'Addition',
    Percent: 'Percent',
    Total: 'Total',
  },

  additions: {
    value: 'Value',
    valueType: 'Value Type',
    name: 'Name',
    hour1: 'Start Time',
    hour2: 'End Time',
    date1: 'Start Date',
    date2: 'End Date',
    cancel: 'Cancel',
    addAddition: 'Add Addition',
    priority: 'Priority',
    weekDays: 'Week Days',
    newAddition: 'New Addition',
    price: 'Price',
    total: 'Total',
    percent: 'Percent',
    columnExist: 'Title allready exists',
  },

  toast: {
    error: {
      badResponse: '[Location] bad server response',
    },
  },

  create: {
    successToast: {
      message: 'Success! Rate Created',
    },
    errorToast: {
      message: 'Error occurred. Could Not Create Rate',
    },
  },

  edit: {
    successToast: {
      message: 'Success! Rate Updated',
    },

    errorToast: {
      message: 'Error occurred. Could Not Update Rate',
    },

    modalError: {
      header: 'Error.',
      body: 'Can not update rate.',
    },
  },

  delete: {
    successToast: {
      message: '[Rates] deleted successfully',
    },

    errorToast: {
      message: '[Rates] bad server response',
    },
  },

  forms: {
    update: {
      tabs: {
        generalInfo: 'General Information',
        generalAdditions: 'General Additions',
        attributeAdditions: 'Attribute Additions',
        geoAdditions: 'Geo Additions',
        history: 'History',
      },
    },

    header: {
      createRate: {
        title: 'Create',
      },

      updateRate: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    isActive: {
      fields: {
        isActive: {
          on: 'Active',
          off: 'Inactive',
        },
      },
    },

    information: {
      details: {
        header: 'Rate Details',
        fields: {
          units: {
            name: 'Sites',
          },
          from: {
            name: 'From',
          },
          to: {
            name: 'To',
          },
          supplierId: {
            name: 'Supplier',
          },
          servicesIds: {
            name: 'Service',
          },
          profilesIds: {
            name: 'Profile',
          },
          attributesIds: {
            name: 'Attribute',
          },
          biDirectional: {
            name: 'Bi-Directional',
          },
          group: {
            name: 'Rate Group',
          },
          name: {
            name: 'Name',
          },
          code: {
            name: 'Code',
          },
        },
      },
    },

    type: {
      header: 'Rate Type',
      fields: {
        fromAreasIds: 'From Zone',
        toAreasIds: 'To Zone',
        biDirectional: 'Bi-Directional',
        basePrice: 'Base Price',
        durationFactors: {
          baseDuration: 'Base Duration',
          pricePerAdditional: {
            value: 'Per Additional Minute',
            type: {
              fixed: 'Fixed',
              percentage: 'Percentage (From Base)',
            },
          },
        },
        distanceFactors: {
          baseDistance: 'Base Distance',
          pricePerAdditional: {
            value: 'Per Additional KM/Mil',
            type: {
              fixed: 'Fixed',
              percentage: 'Percentage (From Base)',
            },
          },
        },
      },
      addBtn: 'Add',
    },

    availability: {
      header: 'Rate Availability',
      fields: {
        from: 'Available From',
        to: 'Available Until',
        fromTime: 'Time From',
        toTime: 'Time To',
        weekDays: 'Weekdays',
      },
      addBtn: 'Add Availability',
    },

    addition: {
      header: 'General Additions',
      fields: {
        stops: {
          included: 'Included Stops',
          pricePerAddition: {
            value: 'Per Additional Stop',
            type: {
              fixed: 'Fixed',
              percentage: 'Percentage (From Base)',
            },
          },
        },
        seats: {
          included: 'Included Seats',
          pricePerAddition: {
            value: 'Per Additional Seat',
            type: {
              fixed: 'Fixed',
              percentage: 'Percentage (From Base)',
            },
          },
        },
      },
    },

    peakHoursSurcharge: {
      header: 'Peak Hours Surcharge',
      fields: {
        name: 'Name',
        fromTime: 'From',
        toTime: 'To',
        priceAddition: {
          value: 'Price Addition',
          type: {
            fixed: 'Fixed',
            percentage: 'Percentage (From Base)',
          },
        },
        weekDays: 'Weekdays',
      },
      addBtn: 'Add Peak Hours Surcharge',
    },

    attributeAdditions: {
      header: 'Attribute Addition Details',
      fields: {
        attributeIds: 'Attribute(s)',
        included: 'Included Quantity',
        perAdditional: {
          value: 'Per Additional Attribute',
          type: {
            fixed: 'Fixed',
            percentage: 'Percentage (From Base)',
          },
        },
      },
      addBtn: 'Add Attributes',
    },

    geoAdditions: {
      generalAreaEntrance: {
        header: 'General Zone Entrance',
        fields: {
          pricePerArea: 'Price Per Zone',
          chargingMethod: {
            name: 'Charging Method',
            options: {
              drivingThrough: 'Driving Through',
              stops: 'Stops',
            },
          },
          type: {
            fixed: 'Fixed',
            percentage: 'Percentage (From Base)',
          },
        },
      },
      specificAreaEntrance: {
        header: 'Specific Zone Entrance',
        fields: {
          areasIds: 'Zone',
          pricePerArea: 'Price Per Zone',
          chargingMethod: {
            name: 'Charging Method',
            options: {
              drivingThrough: 'Driving Through',
              stops: 'Stops',
            },
          },
          type: {
            fixed: 'Fixed',
            percentage: 'Percentage (From Base)',
          },
        },
        addBtn: 'Add Zone',
      },
    },
  },
};

export default rates;
